import ColumnsContent from 'components/Hocs/ColumnsContent';
import ContentMain from './NewCompetitions';

export default ColumnsContent(ContentMain);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/NewCompetitions/index.js